import { render, staticRenderFns } from "./InstanceControl.vue?vue&type=template&id=1beabe70&"
import script from "./InstanceControl.vue?vue&type=script&lang=js&"
export * from "./InstanceControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports